const Granularity = {
    MINUTE: "minute",
    HOUR: "hour",
    DAY: "day",
    WEEK: "week",
    MONTH : "month",
    YEAR: "year"
}

export default Granularity;